<template>
    <div class="card" :style="stylealpha" :class="{ active: item.active === false }">
        <div class="card-checkbox"><CustomCheckbox :id="item.id" v-model="checked" /></div>
        <div class="card-content card--object" :style="style">
            <CustomIcon v-if="item.theme" :icon="item.theme.icon" :color="item.theme.color" />
            <span class="card-title">{{ item.name }}</span>
            <span class="card-title" v-if="item.active !== true">[désactivé]</span>
            <span class="card-title" v-if="item.auto !== false">[validation automatique]</span>
            <div class="card-actions">
                <font-awesome-icon
                    v-if="item.active !== true"
                    title="Activer le groupe"
                    icon="toggle-off"
                    class="card-actions--icon enable"
                    @click="handleDisable(item.id)"
                />
                <font-awesome-icon
                    v-if="item.active !== false"
                    title="Désactiver le groupe"
                    icon="toggle-on"
                    class="card-actions--icon enable"
                    @click="handleDisable(item.id)"
                />
                <font-awesome-icon
                    v-if="item.auto !== true"
                    title="Activer la validation auto"
                    icon="toggle-off"
                    class="card-actions--icon auto"
                    @click="handleAuto(item.id)"
                />
                <font-awesome-icon
                    v-if="item.auto !== false"
                    title="Désactiver la validation auto"
                    icon="toggle-on"
                    class="card-actions--icon auto"
                    @click="handleAuto(item.id)"
                />
                <font-awesome-icon
                    title="Modifier"
                    icon="pencil-alt"
                    class="card-actions--icon"
                    @click="handleEdit(item.id)"
                />
                <font-awesome-icon
                    title="Supprimer"
                    icon="trash-alt"
                    class="card-actions--icon alert"
                    @click="handleConfirm(item.id)"
                />
            </div>
        </div>
    </div>
</template>

<script>
import CustomCheckbox from '@/components/Checkbox';
import CustomIcon from '@/components/Icon';

export default {
    props: {
        item: { type: Object, required: true },
        selected: [Array],
        handleDisable: { type: Function },
        handleAuto: { type: Function },
        handleEdit: { type: Function },
        handleConfirm: { type: Function },
    },

    computed: {
        style() {
            if (this.item.auto) {
                return `border-radius:15px;border-right:10px solid greenyellow;width:100%;`;
            } else {
                return ``;
            }
        },
        stylealpha() {
            return `background: ${this.item.theme.color}1A;`;
        },
    },

    data() {
        return {
            checked: this._getCheck(this.selected),
        };
    },
    watch: {
        selected(val) {
            this.checked = this._getCheck(val);
        },
        checked(val) {
            this.$emit('selected', { id: this.item.id, checked: val });
        },
    },
    methods: {
        _getCheck(val) {
            return val && val.some((s) => s === this.item.id);
        },
    },
    components: {
        CustomCheckbox,
        CustomIcon,
    },
};
</script>

<style lang="scss">
.card--object {
    display: flex;
    align-items: center;

    .card-title {
        margin-left: 10px;
    }
}

.card.active {
    background-color: #ccc !important;
}
.cards .card.active .card-content .card-title {
    color: #666 !important;
}
</style>
